export const visitorSelector = state => state.whiteLabel.visitor.get('visitorName');
export const loadingSelector = state => state.whiteLabel.visitor.get('isLoading');
export const goToSelector = state => state.whiteLabel.visitor.get('goTo');
export const matchesSelector = state => state.whiteLabel.visitor.get('matches');
